<div class="flyout-backdrop" (click)="close()" aria-hidden="true"></div>

<div
  class="flyout-panel"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="ariaLabel"
  [style.top]="flyoutTop"
  [style.left]="flyoutLeft"
  [style.max-height]="'min(50rem, calc(100vh - ' + flyoutTop + ' - 1rem))'"
>
  <div class="flyout-body">
    <app-switcher-content></app-switcher-content>
  </div>
</div>
